fbm.add("commands/pip", ["util/io", "util/pause", "util/screens"], function (uio, upause, cscreens) {


    let {
        el,
        type,
        pause,
        clear
    } = {
        ...uio,
        ...cscreens,
        ...upause,
    }

    const pipTpl = `<div id="pip-boi" class="d-flex" style="height: 100%;">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h2 style="padding: 0 1rem; font-size: 2rem;">Create Your EAI Security Identification Badge</h2>
                    <div class="border-frame" style="border: 3px solid;height: 10px;border-bottom: none;"></div>
                </div>
            </div>
            <div class="row p-3" style="height: calc(100% - 115px);">
    
                <div id="menuCol" class="col-6" style="height: 100%;">
                    <div class="sub-menu-title-bar mb-2" style="display:none;">
                        <a class="back-button d-inline-block mb-2" href="javascript:" id="backToRoot" style="text-decoration:none;">&lt;-Back to Trait Selection</a><br>
                        <span class="category-title fs-3"></span>
                    </div>
                    <ul id="rootMenu" class="trait-cats list-unstyled menu">
                        Traits:<br>
                    </ul>
                </div>
                <div class="col-6 align-self-top" id="ape">
                    <p>Please select an ape trait</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="bottom-border-frame" style="border: 3px solid;height: 10px;border-top: none;"></div>
                    <div class="bottom-buttons d-flex mx-3 justify-content-between">
                        <a href="javascript:" class="submit bottom-button" id="apein">Submit</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`;

    const atariLogo = "data:image/png;base64,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"

    let traitData = {};
    const basePath = "/nft-api/composite"

    let myApe = {};
    let traitLookup = [];
    let isProp = null;
    let myProps = null;
    let selectedProp = null;
    let selectedToken = null;
    let nonce = Date.now();
    const terms = `Signing this message will allow you to interact with the Fight Back Apes claim interface. This signature will not cause any blockchain transactions, it is used purely to validate wallet ownership.`;
    let sig = null;
    let sighash = null;
    let onerror;

    function createMenus() {
        const menuCol = document.getElementById('menuCol');
        const traitCats = document.querySelector('.trait-cats');
        const options = document.getElementById('apetions')

        // Top level first
        const cats = ['Ape', 'Fur', 'Background', 'Top', 'Eyes', 'Eye Color', 'Mouth', 'Headwear', 'Jewelry', 'Prop'];
        cats.forEach(cat => {
            const li = document.createElement('li');
            li.innerHTML = `<span id="selected-${cat}">( )</span> <a class="green category-link ${(cat === "Ape") ? "" : "disabled"}" data-category="${cat}" href="javascript:">${cat}</a>`;
            li.querySelector('a').onclick = () => {
                changeMenu(cat.toLowerCase().replace(/ /g, '_') + 'Menu');
            };
            traitCats.appendChild(li);

            // Now we need all the other menus made
            const newMenu = document.createElement('div');
            setAttributes(newMenu, {
                "id": cat.toLowerCase().replace(/ /g, '_') + "Menu",
                "data-category": cat,
                "class": "cat-menu menu"
            })
            const propL = [];
            let none = null;
            traitData[cat].forEach(option => {
                const atari = isProp[option.Name.toUpperCase()];
                const iOwnsIt = myProps[option.Name.toUpperCase()];
                if (atari && !iOwnsIt) {
                    return;
                }
                const l = document.createElement('label');
                const r = document.createElement('input');
                const s = document.createElement('span');
                setAttributes(l, {"class": "option-wrap", "for": (option.Name.toLowerCase()).replace(/ /g, '_')})
                setAttributes(r, {
                    "type": "radio",
                    "name": cat,
                    "value": option.ID,
                    "class": "trait-option",
                    "data-reqs": JSON.stringify(option.Requirements),
                    "data-id": option.ID,
                    "id": (option.Name.toLowerCase()).replace(/ /g, '_'),
                });
                r.checked = myApe[cat] === option.ID.toString();
                l.onclick = () => {
                    myApeChange(cat, option.ID);
                    const i = l.querySelectorAll('input');
                    i[0].checked = true
                }
                l.appendChild(r);
                l.appendChild(s);
                if (atari) {
                    const img = document.createElement("img")
                    img.src = atariLogo;
                    img.height = 20;
                    img.width = 20;
                    img.style.marginRight = "6px"
                    l.appendChild(img);
                }
                l.appendChild(document.createTextNode(option.Name));
                if (atari) {
                    propL.push(l);
                } else if (option.Name.toLowerCase() === 'none') {
                    none = l;
                } else {
                    newMenu.appendChild(l);
                }
            });
            for (let i = propL.length - 1; i >= 0; i--) {
                newMenu.prepend(propL[i]);
            }
            if (none !== null) {
                newMenu.prepend(none);
            }
            menuCol.appendChild(newMenu);
        });
        // default to black so images work
        setDefaults();
    }

    function myApeChange(k, v) {
        unlockMenus();
        const name = traitLookup[v].toUpperCase();
        if (isProp[name] && !myProps[name]) {
            alert('Token Ownership Lookup Failure');
            return;
        }
        if (isProp[name]) {
            if (selectedProp !== null && selectedProp !== v) {
                document.querySelector('#ape p').innerText = 'ATARI Traits Limited To 1 Per Ape'
                for (let i in myApe) {
                    if (myApe[i] === selectedProp) {
                        document.getElementById('selected-' + i).innerText = "( )";
                        myApe[i] = null;
                        break;
                    }
                }
            }
        }
        const isNew = (k === 'Ape' && !myApe[k]);
        myApe[k] = v;
        checkProps();
        document.getElementById('selected-' + k).innerText = "(X)";
        loadApe();
        checkRequirements();
        if (isNew) {
            document.querySelector('#ape p').innerText = 'A random Background was selected, you can change this by clicking on the trait.';
        }
    }

    function checkProps() {
        if (myApe === null) {
            return;
        }
        let hasProp = false;
        let count = 0;
        for (let i in myApe) {
            if (!myApe[i]) {
                continue;
            }
            count++;
            const name = traitLookup[myApe[i]].toUpperCase();
            if (!isProp[name]) {
                continue;
            }
            selectedProp = myApe[i];
            selectedToken = myProps[name][0];
            hasProp = true;
        }
        if (!hasProp) {
            selectedToken = null;
            selectedProp = null;
        }
        document.getElementById('apein').classList.toggle('disabled', (count !== 10));
    }

    function unlockMenus() {
        document.querySelector('#ape p').innerText = '';
        const cats = document.querySelectorAll('.category-link');
        cats.forEach(cat => {
            cat.classList.remove('disabled')
        });
    }

    function checkRequirements() {
        // Disable non valid options
        // LETS GET CONVOLUTED!
        const options = document.querySelectorAll('.trait-option');
        const noReq = [];
        const yesReq = [];
        options.forEach(option => {
            // get each options Id and requirements
            const id = option.dataset['id'];
            const reqs = JSON.parse(option.dataset['reqs']);
            // since there are multiple conditions
            // lets check if it meets any of the conditions
            let meetsReqs = [];
            if (reqs !== null) {
                // each array within the requirements array is another
                // win condition so lets see if each ID inside passes
                reqs.forEach(r => {
                    // Default to win
                    let passReq = true;
                    // Fail if missing any id in win condition
                    r.forEach(trait => {
                        if (Object.values(myApe).indexOf(trait) < 0) {
                            passReq = false;
                        }
                    });
                    // push this status into our array of results
                    meetsReqs.push(passReq)
                });
                // finally if no wins, disable the radio input
                if (!meetsReqs.includes(true)) {
                    option.disabled = true;
                    option.parentElement.style.display = 'none';
                    if (yesReq.indexOf(id) === -1) { // if its not in the "yes"
                        if (noReq.indexOf(id) === -1) { // if its not in the "no" add it
                            noReq.push(id);
                        }
                    }
                } else {
                    option.disabled = false;
                    option.parentElement.style.display = 'block'
                    if (yesReq.indexOf(id) === -1) { // if its not in the "yes" add it
                        yesReq.push(id);
                    }
                    let idx = noReq.indexOf(id)
                    if (idx >= 0) { // if it IS in the "no" delete it
                        noReq[idx] = null;
                        delete (noReq[idx]);
                    }
                }
            }
        });

        if (myApe === null) {
            return;
        }
        let changed = [];
        for (let i in myApe) {
            if (noReq.indexOf(myApe[i].toString()) === -1) {
                continue;
            }
            document.getElementById('selected-' + i).innerText = "( )";
            myApe[i] = null;
            changed.push(i);
        }
        setDefaults();

        if (changed.length > 0) {
            document.querySelector('#ape p').innerText = 'Some trait combos are not available and have been reset';
        }
    }

    let st = null;

    function setDefaults() {
        if (!myApe['Ape']) {
            return;
        }
        if (!myApe['Fur']) {
            myApe['Fur'] = traitData.Fur[0].ID;
        }
        if (!myApe['Background']) {
            let x = Math.round(Math.random() * traitData.Background.length);
            myApe['Background'] = traitData.Background[x].ID;
            document.getElementById('selected-Background').innerText = "(X)";
            let input = document.querySelector(`input[name="Background"][value="${myApe['Background']}"]`);
            input && (input.checked = true);
        }
        console.log(myApe);
    }

    function loadApe() {
        if (st !== null) {
            clearTimeout(st);
            st = null;
        }
        st = setTimeout(() => {
            const ape = document.getElementById("ape");
            let i = ape.querySelector('img');
            let newImg = false;
            if (i === null) {
                i = document.createElement("img");
                i.style.maxWidth = "1000px";
                i.style.maxHeight = "1000px";
                i.style.minHeight = "200px";
                i.style.width = "100%";
                i.style.border = "2px dashed";
                i.classList.add('img-fluid');
                i.style.background = "url(https://cdn.daz3d.com/file/dazcdn/media/fight-back-apes/loading-bg.gif) center no-repeat";
                i.onerror = () => {
                    alert('An error occurred loading the ape, please view console for data');
                }
                newImg = true;
            }

            i.src = getImageUrl();

            newImg && ape.prepend(i);
        }, 250)
    }

    function getImageUrl() {
        const data = {
            id: 1,
            image: "jpg",
            authSig: sig,
            authHash: sighash,
            authWallet: dazethutil.me(),
            authNonce: nonce,
            'attributes': Object.values(myApe).join(',')
        };
        const queryString = Object.keys(data).map((k) => {
            return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
        }).join('&');
        return basePath + "/?" + queryString;
    }

    function changeMenu(id) {
        const all = document.querySelectorAll('.menu');
        const changeTo = document.getElementById(id);
        const sub = document.querySelector('.sub-menu-title-bar');
        const but = document.querySelector('.bottom-buttons');
        const cat = document.querySelector('.category-title');
        all.forEach(menu => {
            menu.style.display = 'none';
        });
        if (id !== 'rootMenu') {
            document.getElementById('apein').style.display = "none";
            cat.innerText = changeTo.getAttribute('data-category') + ':';
            sub.style.display = 'block';
            but.style.display = 'block';
        } else {
            document.getElementById('apein').style.display = "block";
            sub.style.display = 'none';
            but.style.display = 'none';
        }
        changeTo.style.display = 'block';
    }

    function setAttributes(el, attrs) {
        for (var key in attrs) {
            if (key === 'checked' && attrs[key] === false) {
                continue;
            }
            el.setAttribute(key, attrs[key]);
        }
    }

    function getTraitUrl() {
        const data = {
            id: 1,
            authSig: sig,
            authHash: sighash,
            authWallet: dazethutil.me(),
            authNonce: nonce,
        };
        const queryString = Object.keys(data).map((k) => {
            return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
        }).join('&');
        return basePath + "/traits?" + queryString;
    }

    async function getApeData() {
        if (isProp === null) {
            isProp = {};
            for (let i in props) {
                isProp[props[i].Name.toUpperCase()] = true;
            }
        }
        await updateProps();

        return fetch(getTraitUrl()).then(async response => {
            if (!response.ok) {
                throw await response.text();
            }
            return response.json();
        }).then(async td => {
            traitData = td;
            for (const cat in traitData) {
                if (Object.hasOwnProperty.call(traitData, cat)) {
                    const category = traitData[cat];
                    for (const trait in category) {
                        if (Object.hasOwnProperty.call(category, trait)) {
                            const t = category[trait];
                            traitLookup[t.ID] = t.Name
                        }
                    }
                }
            }
        }).catch(async txt => {
            let err = "";
            try {
                err = JSON.parse(txt);
            } catch (e) {
                err = {error: txt};
            }
            window.dispatchEvent(new CustomEvent("mint_error", {detail: {when: "sign", error: err.error}}));
            throw err.error;
        });
    }

    async function updateProps() {
        const factoryContract = new window.dazeth.web3.eth.Contract(window.dazContracts["MonkeyFactory"], window.fbaConfig.factory);
        const propsAvailable = await factoryContract.methods.propsAvailable().call({from: dazethutil.me()});
        myProps = {};
        for (let i in propsAvailable) {
            const name = propName(propsAvailable[i]).toUpperCase();
            if (!myProps.hasOwnProperty(name)) {
                myProps[name] = [];
            }
            myProps[name].push(propsAvailable[i]);
        }
    }

    function propName(index) {
        index = parseInt(index, 10);
        return props[tokens[index]].Name;
    }

    async function pip(reset = true) {
        if (reset) {
            selectedProp = null;
            selectedToken = null;
            myApe = {};
            myProps = null;
        }
        return new Promise(async (resolve, reject) => {
            onerror = reject;

            if (sig === null || sighash === null) {
                await type(["Sign the message with your wallet to identify yourself with the artifact"], {lineWait: 0});
                const text = `${terms}\n\nWallet: ${dazethutil.me()}\n\nTimestamp: ${nonce}`;
                try {
                    sig = await dazeth.web3.eth.personal.sign(text, dazethutil.me());
                    sighash = dazethutil.hash([text]);
                } catch {
                    await type(["... IDENTIFICATION FAILURE ..."], {lineWait: 300});
                    onerror();
                    return;
                }

                await type(["... ACCESS GRANTED ..."], {lineWait: 300});
                await pause(2);
                await clear();
            }

            const div = el("div");
            div.style.height = "100%";
            div.innerHTML = pipTpl;
            div.querySelector('#backToRoot').onclick = () => {
                changeMenu('rootMenu');
            };
            const apein = div.querySelector('#apein');
            apein.classList.toggle('disabled', true);
            apein.onclick = (e) => {
                resolve({traits: Object.values(myApe), prop: selectedToken, url: getImageUrl()});
            }

            await getApeData();
            createMenus();
            if (!reset) {
                for (var i in myApe) {
                    myApeChange(i, myApe[i]);
                }
            }
        })
    }

    return {
        pip: pip,
    };
});
